import React from 'react';
import { Card } from './ui/card';
import { processData } from '../data/mock';

const Process = () => {
  return (
    <section id="process" className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4">
              {processData.title}
            </h2>
            <div className="w-24 h-1 bg-[#2d8b8b] mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              {processData.subtitle}
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {processData.steps.map((step, index) => (
              <Card key={index} className="relative p-8 hover:shadow-xl transition-all duration-300 bg-white border-2 border-gray-100 hover:border-[#2d8b8b]">
                {/* Step Number */}
                <div className="absolute -top-6 left-8">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#1e3a5f] to-[#2d8b8b] rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-lg">{step.number}</span>
                  </div>
                </div>

                <div className="mt-8">
                  <h3 className="text-xl font-bold text-[#1e3a5f] mb-3">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Connection Line (except last item) */}
                {index < processData.steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-[#2d8b8b]/30"></div>
                )}
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
